import MuiBottomNavigation from '@material-ui/core/BottomNavigation';

export default MuiBottomNavigation;
